// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__3mTwZ","header":"PatientBlock_header__24ICE","label":"PatientBlock_label__2s-Vs","option":"PatientBlock_option__GfRbP"};